"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UniverseLogError_1 = require("../error/UniverseLogError");

var JsonLogFormat_1 = require("./JsonLogFormat");

var OnelineLogFormat_1 = require("./OnelineLogFormat");

var LogFormat;

(function (LogFormat) {
  LogFormat.FORMATS = {
    json: new JsonLogFormat_1.JsonLogFormat(false),
    json_pretty: new JsonLogFormat_1.JsonLogFormat(true),
    oneline: new OnelineLogFormat_1.OnelineLogFormat()
  };
  LogFormat.DEFAULT_FORMAT = LogFormat.FORMATS.oneline;

  function valueOf(name) {
    if (typeof LogFormat.FORMATS[name] === "undefined") {
      var availableLevels = Object.keys(LogFormat.FORMATS).join(",");
      throw new UniverseLogError_1.UniverseLogError("There is no such log format: '".concat(name, "'. Available formats: [ ").concat(availableLevels, " ]"));
    }

    return LogFormat.FORMATS[name];
  }

  LogFormat.valueOf = valueOf;
})(LogFormat = exports.LogFormat || (exports.LogFormat = {}));